import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchRecipients } from "../../store/campaignStore/campaignActions";
import styles from "./campaigns.module.scss";

const FILTERS = ["all", "sent", "failed", "pending", "skipped"];

const RecipientList = ({ campaignID }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const recipients = useSelector((s) => s.campaignReducer.recipients);
    const [filter, setFilter] = useState("all");

    useEffect(() => {
        const params = filter === "all" ? {} : { status: filter };
        dispatch(fetchRecipients(campaignID, params));
    }, [campaignID, filter, dispatch]);

    return (
        <div className={styles.recipientList}>
            <div className={styles.filterBar}>
                {FILTERS.map((f) => (
                    <button
                        key={f}
                        type="button"
                        className={filter === f ? styles.filterActive : styles.filter}
                        onClick={() => setFilter(f)}
                    >
                        {t(`NSCampaigns.recipients${capitalize(f)}`)}
                    </button>
                ))}
            </div>
            <div className={styles.tableWrap}>
                <table className={styles.recipientTable}>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Phone</th>
                            <th>Status</th>
                            <th>Attempt</th>
                            <th>Error</th>
                        </tr>
                    </thead>
                    <tbody>
                        {recipients.map((r, i) => (
                            <tr key={`${r.phone}-${i}`}>
                                <td>{r.idx ?? i}</td>
                                <td>{r.phone}</td>
                                <td>{r.status}</td>
                                <td>{r.attempt_count || 0}</td>
                                <td>{r.error_message || ""}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

function capitalize(s) {
    return s ? s[0].toUpperCase() + s.slice(1) : s;
}

export default RecipientList;
